export const getLastPoolRequestId = state => state.poolRequest.lastInteractiveId;